export class TeaserClient {
	async get(url: string): Promise<string> {
		try {
			const response = await window.fetch(url, {
				headers: {
					Accept: "text/html;charset=UTF-8",
					"X-Requested-With": "XMLHttpRequest",
				},
			});

			const responseText = await response.text();
			if (response.status === 200 || response.status === 204) {
				return responseText;
			}

			/*                                    */
			throw Error(`${responseText}`);
		} catch (error: unknown) {
			if (error instanceof Error) {
				throw Error(`could not retrieve partner benefit teaser '${error.message}'`);
			}
			if (typeof error === "string") {
				throw Error(`could not retrieve partner benefit teaser '${error}'`);
			}
			throw error;
		}
	}
}
